document.addEventListener('DOMContentLoaded',()=>{
  // Product gallery: native horizontal scrolling + arrows/thumbnails/swipe.
  document.querySelectorAll('[data-cv18-gallery]').forEach(g=>{
    const track=g.querySelector('[data-cv18-track]');
    const slides=[...g.querySelectorAll('.cv18-slide')];
    const thumbs=[...g.parentElement.querySelectorAll('[data-cv18-thumb]')];
    const cur=g.querySelector('[data-cv18-current]');
    if(!track || !slides.length) return;
    let i=0;
    const update=(n, smooth=true)=>{
      i=(n+slides.length)%slides.length;
      track.scrollTo({left:i*track.clientWidth,behavior:smooth?'smooth':'auto'});
      thumbs.forEach((t,x)=>{t.classList.toggle('active',x===i);t.setAttribute('aria-selected',x===i?'true':'false');});
      if(cur) cur.textContent=i+1;
    };
    const sync=()=>{
      const next=Math.round(track.scrollLeft/Math.max(track.clientWidth,1));
      if(next!==i) update(next,false);
    };
    g.querySelector('[data-cv18-prev]')?.addEventListener('click',()=>update(i-1));
    g.querySelector('[data-cv18-next]')?.addEventListener('click',()=>update(i+1));
    thumbs.forEach(t=>t.addEventListener('click',()=>update(Number(t.dataset.cv18Thumb))));
    track.addEventListener('scroll',()=>{window.requestAnimationFrame(sync)});
    window.addEventListener('resize',()=>update(i,false));
    g.addEventListener('keydown',e=>{if(e.key==='ArrowLeft') update(i-1); if(e.key==='ArrowRight') update(i+1);});
    update(0,false);
  });

  // Mobile navigation.
  const menu=document.querySelector('[data-cv18-menu]');
  const nav=document.querySelector('[data-cv18-nav]');
  menu?.addEventListener('click',()=>{
    const open=nav.classList.toggle('open');
    menu.setAttribute('aria-expanded',open?'true':'false');
  });
  nav?.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>nav.classList.remove('open')));
});
